import {
    CORE_GET_ALL_CAR_REQUEST,
    CORE_GET_ALL_CAR_SUCCESS,
    CORE_GET_ALL_CAR_FAILURE,

    CORE_GET_ALL_FUEL_REQUEST,
    CORE_GET_ALL_FUEL_SUCCESS,
    CORE_GET_ALL_FUEL_FAILURE,

    CORE_GET_CAR_BY_ID_REQUEST,
    CORE_GET_CAR_BY_ID_SUCCESS,
    CORE_GET_CAR_BY_ID_FAILURE,


} from '../../carReservationType'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    cars: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_CAR_REQUEST:
                return state
            case CORE_GET_ALL_CAR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_CAR_FAILURE:
                return []
            default:
                return state
        }
    },
    car: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_CAR_BY_ID_REQUEST:
                return state
            case CORE_GET_CAR_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_CAR_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    oilType: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_FUEL_REQUEST:
                return state
            case CORE_GET_ALL_FUEL_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_FUEL_FAILURE:
                return []
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/carReserve/car.js